export class AsyncInfoRequestViewModel {
    public Id: number;
    public Caption: string;
    public Description: string;
}

export class AsyncInfoResponseViewModel {
    public Id: number;
    public Caption: string;
    public Date: Date;
    public Description: string;
    public Status: number;
}
